module.exports = __webpack_public_path__ + "img/jr_banner_hk.c343700d.jpg";